// PLEX-6049: an image the model generated (Bedrock ImageBlockStart + ImageBlockDelta), as
// opposed to a file the user attached (source.file). It can be drawn only when its source is
// base64 bytes with a known format; returns a data: URL for <img src>, or null.
const FORMATS = new Set(["png", "jpeg", "gif", "webp"]);

export const generatedImageSrc = (image) => {
  if (!image || image.source?.file) return null;
  const {format, source} = image;
  const bytes = source?.bytes;
  if (!FORMATS.has(format) || typeof bytes !== "string" || !bytes) return null;
  return /^[A-Za-z0-9+/=\s]+$/.test(bytes) ? `data:image/${format};base64,${bytes.replace(/\s/g, "")}` : null;
};
